module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('scroll', {
    on: {
      "refresh": _vm.refresh
    }
  }, [_c('no-record', {
    attrs: {
      "condition": _vm.characterInfo,
      "tips": "暂无数据"
    }
  }), _vm._v(" "), _c('section', [_c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("身高")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm._f("formatCharacterInfo")(_vm.characterInfo.height)))])]), _vm._v(" "), _c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("体重")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm._f("formatCharacterInfo")(_vm.characterInfo.weight)))])]), _vm._v(" "), _c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("BMI")]), _vm._v(" "), _c('dd', [_vm._v("\n                    " + _vm._s(_vm._f("formatCharacterInfo")(_vm.characterInfo.bmi)) + "\n                ")])]), _vm._v(" "), _c('dl', {
    staticClass: "field last"
  }, [_c('dt', [_vm._v("血型")]), _vm._v(" "), _c('dd', [_vm._v("\n                    " + _vm._s(_vm._f("formatCharacterInfo")(_vm.characterInfo.blood)) + "\n                ")])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-442c085d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/healthRecord/Character.vue
// module id = 821
// module chunks = 0